import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails, ContractorResponseDto } from 'app/services/authentication/connection/interfaces/apiInterfaces';

export class GetContractorByEntityIdCommand extends IRequestCommand<IGetContractorByEntityIdResponse, ErrorDetails, IGetContractorByEntityIdCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'contractors/{id}';
  public override setParameters(parameters: IGetContractorByEntityIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace('{id}', parameters.id);
  };
}

export interface IGetContractorByEntityIdCommandParameters extends ICommandParameters {
  id: string;
}

export interface IGetContractorByEntityIdResponse extends ContractorResponseDto, ICommandResponse {

}
